import React from 'react';
import { Box, Button, Stack, Typography, alpha } from '@mui/material';
import { getAccentColor, getBodyColor } from './shared';

const SocialLinksSection = ({ section, sectionKey, socialLinks, isAdmin, editMode, openActionPath, renderHtmlTextBlock }) => {
  const accent = getAccentColor(section) || '#4F46E5';
  const bodyColor = getBodyColor(section) || '#64748B';

  return (
    <Box component="section" sx={{ py: { xs: 0.8, md: 1.2 }, width: '100%' }}>
      <Stack spacing={4}>
        {(section.title || section.body) && (
          <Stack spacing={1.5} textAlign="center">
            {section.title && <Typography component="h2" sx={{ color: '#0F172A', fontWeight: 800, fontSize: { xs: '1.8rem', md: '2.25rem' }, letterSpacing: '-0.02em' }}>{section.title}</Typography>}
            {section.body && renderHtmlTextBlock(section.body, { color: bodyColor, lineHeight: 1.7, fontSize: '1.1rem', textAlign: 'center' })}
          </Stack>
        )}
        {socialLinks.length ? (
          <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' } }}>
            {socialLinks.map((item, index) => (
              <Button key={`${sectionKey}-social-${index}`} variant="outlined" onClick={() => { if (!(isAdmin && editMode) && item.url) openActionPath(item.url); }} sx={{ justifyContent: 'flex-start', p: 2, borderRadius: '6px', border: `1px solid ${alpha('#0F172A', 0.1)}`, color: '#0F172A', textTransform: 'none', transition: 'all 0.3s', '&:hover': { backgroundColor: alpha(accent, 0.04), borderColor: alpha(accent, 0.2), transform: 'translateY(-4px)', boxShadow: `0 8px 20px ${alpha('#0F172A', 0.04)}` } }}>
                <Stack direction="row" spacing={2} alignItems="center" sx={{ width: '100%' }}>
                  <Box sx={{ width: 48, height: 48, borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: accent, backgroundColor: alpha(accent, 0.1), fontWeight: 800, fontSize: '1.2rem' }}>
                    {String(item.icon || item.label || 's').slice(0, 2)}
                  </Box>
                  <Box sx={{ textAlign: 'left', overflow: 'hidden' }}>
                    <Typography sx={{ fontWeight: 800, fontSize: '1rem' }}>{item.label || ''}</Typography>
                    <Typography sx={{ color: '#64748B', fontSize: '0.8rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.url || ''}</Typography>
                  </Box>
                </Stack>
              </Button>
            ))}
          </Box>
        ) : (
          <Typography sx={{ color: bodyColor, textAlign: 'center' }}>Add social links in the editor.</Typography>
        )}
      </Stack>
    </Box>
  );
};
export default SocialLinksSection;
